export var handleInfoMessage = function () {
    var alert = document.getElementsByClassName("alert")[0];
    if (alert) {
        var classList = alert.classList;
        if (alert && alert.innerHTML.includes("[INFO]")) {
            if (classList.contains("alert-success")) {
                classList.remove("alert-success");
                classList.add("alert-info");
                alert.innerHTML = alert.innerHTML.slice(15);
            }
            else if (classList.contains("alert-danger")) {
                classList.remove("alert-danger");
                classList.add("alert-info");
                alert.innerHTML = alert.innerHTML.slice(15);
            }
        }
        else if (alert && alert.innerHTML.includes("[WARNING]")) {
            if (classList.contains("alert-success")) {
                classList.remove("alert-success");
                classList.add("alert-warning");
                alert.innerHTML = alert.innerHTML.slice(22);
            }
            else {
                classList.remove("alert-danger");
                classList.add("alert-warning");
                alert.firstElementChild.firstElementChild.innerHTML =
                    alert.firstElementChild.firstElementChild.innerHTML.slice(10);
            }
        }
    }
};
